// frontend/src/pages/FAQ.jsx
import { useState } from "react";
import { ArrowLeft, Download, ChevronDown, ChevronUp } from "lucide-react";

export default function FAQ() {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [openSections, setOpenSections] = useState({});

  const pdfUrl = `${process.env.PUBLIC_URL}/pdfs/faq.pdf`;

  const handleDownloadPDF = () => {
    setIsGeneratingPDF(true);
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'faq.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsGeneratingPDF(false);
  };

  const toggleSection = (sectionId) => {
    setOpenSections(prev => ({
      ...prev,
      [sectionId]: !prev[sectionId]
    }));
  };

  // Dados do FAQ
  const faqData = [
    {
      id: 'sobre',
      title: 'Sobre o Brechó Vizinho',
      items: [
        {
          question: 'O que é o Brechó Vizinho?',
          answer: 'O Brechó Vizinho é uma plataforma exclusiva para comunidades e condomínios que conecta moradores através da compra, venda e doação de itens, além de incentivar a divulgação de iniciativas, negócios e serviços da própria comunidade.'
        },
        {
          question: 'Qual é o objetivo da plataforma?',
          answer: 'O Brechó Vizinho foi criado para fortalecer os laços entre moradores, incentivar o reaproveitamento de itens, promover o desenvolvimento sustentável e valorizar os talentos, empreendedores e prestadores de serviços da comunidade.'
        },
        {
          question: 'O Brechó Vizinho é apenas um marketplace?',
          answer: 'Não. Mais do que uma plataforma de compra e venda, o Brechó Vizinho busca promover a integração da comunidade, estimular a economia local e criar oportunidades para que moradores possam se conectar de forma mais próxima e colaborativa.'
        },
        {
          question: 'Quem pode usar o Brechó Vizinho?',
          answer: 'Moradores e proprietários de imóveis localizados em condomínios ou comunidades habilitadas na plataforma. Nosso objetivo é criar um ambiente confiável, voltado para pessoas que compartilham a mesma comunidade.'
        },
        {
          question: 'O Brechó Vizinho é gratuito?',
          answer: 'Sim. A utilização básica da plataforma é gratuita para os moradores. Alguns recursos ou serviços adicionais poderão ser disponibilizados futuramente.'
        }
      ]
    },
    {
      id: 'cadastro',
      title: 'Cadastro e Aprovação',
      items: [
        {
          question: 'Como faço meu cadastro?',
          answer: 'Basta informar seus dados, CEP, endereço, número do imóvel e criar sua conta.'
        },
        {
          question: 'Por que minha conta precisa ser aprovada?',
          answer: 'Para garantir que apenas moradores reais tenham acesso à comunidade e às publicações da plataforma.'
        },
        {
          question: 'Quem aprova minha conta?',
          answer: 'Dependendo do caso, a aprovação poderá ser realizada pelo Proprietário previamente validado; Síndico; Administração do condomínio; Associação de moradores; Conselho gestor da comunidade ou Administradores autorizados da plataforma.'
        },
        {
          question: 'Quanto tempo leva a aprovação?',
          answer: 'O prazo pode variar, mas normalmente a validação ocorre em poucos dias.'
        },
        {
          question: 'Posso usar um apelido em vez do meu nome?',
          answer: 'Sim. Você pode utilizar um nickname para se identificar na plataforma.'
        },
        {
          question: 'A foto de perfil é obrigatória?',
          answer: 'Não. O envio de foto é opcional.'
        }
      ]
    },
    {
      id: 'publicacoes',
      title: 'Publicações',
      items: [
        {
          question: 'O que posso anunciar?',
          answer: 'Você pode anunciar itens para venda ou doação, desde que sejam de sua propriedade e estejam em conformidade com os Termos de Uso da plataforma. Dependendo das funcionalidades disponíveis, também poderão ser divulgados serviços, negócios locais e iniciativas da comunidade.'
        },
        {
          question: 'Posso doar produtos?',
          answer: 'Sim. A plataforma permite tanto anúncios de venda quanto de doação.'
        },
        {
          question: 'Como marcar um item como vendido ou doado?',
          answer: 'Você pode atualizar o status do anúncio para informar que o item não está mais disponível.'
        },
        {
          question: 'Posso editar ou excluir meus anúncios?',
          answer: 'Sim. Você pode editar ou remover seus anúncios a qualquer momento.'
        }
      ]
    },
    {
      id: 'seguranca',
      title: 'Segurança e Convivência',
      items: [
        {
          question: 'O Brechó Vizinho participa das negociações?',
          answer: 'Não. A plataforma apenas facilita a conexão entre os usuários. A negociação, pagamento e entrega são de responsabilidade das partes envolvidas.'
        },
        {
          question: 'Como denunciar um anúncio ou usuário?',
          answer: 'Utilize a opção de denúncia disponível na plataforma. Nossa equipe avaliará cada caso de acordo com os Termos de Uso.'
        },
        {
          question: 'Como sei que um usuário realmente mora na comunidade?',
          answer: 'Todos os usuários passam por um processo de validação antes de terem acesso completo à plataforma.'
        }
      ]
    },
    {
      id: 'chat',
      title: 'Chat e Comunicação',
      items: [
        {
          question: 'Posso conversar com outros moradores?',
          answer: 'Sim. A plataforma disponibiliza ferramentas de comunicação para facilitar o contato entre os usuários.'
        },
        {
          question: 'Posso bloquear outro usuário?',
          answer: 'Sim. Caso necessário, você poderá bloquear usuários com os quais não deseja interagir.'
        }
      ]
    },
    {
      id: 'privacidade',
      title: 'Privacidade',
      items: [
        {
          question: 'Meus dados pessoais ficam visíveis para outros usuários?',
          answer: 'Não. Apenas as informações necessárias para utilização da plataforma são exibidas.'
        },
        {
          question: 'Meu endereço aparece nos anúncios?',
          answer: 'Não. O endereço completo do imóvel não é exibido publicamente.'
        },
        {
          question: 'Como meus dados são protegidos?',
          answer: 'O Brechó Vizinho adota medidas de segurança e privacidade para proteger as informações dos usuários, em conformidade com a legislação aplicável.'
        }
      ]
    },
    {
      id: 'comunidade',
      title: 'Comunidade',
      items: [
        {
          question: 'Meu condomínio ainda não está disponível. O que posso fazer?',
          answer: 'Você poderá manifestar interesse na plataforma e solicitar a inclusão da sua comunidade para futuras expansões.'
        },
        {
          question: 'Posso visualizar conteúdos de outras comunidades?',
          answer: 'Dependendo das configurações da plataforma, poderá haver acesso a conteúdos de comunidades próximas ou a um feed regional.'
        },
        {
          question: 'Como o Brechó Vizinho ajuda a comunidade?',
          answer: 'Ao incentivar o reaproveitamento de itens, fortalecer as relações entre moradores, apoiar empreendedores locais e facilitar a conexão entre pessoas da mesma comunidade, o Brechó Vizinho contribui para uma comunidade mais integrada, sustentável e colaborativa.'
        }
      ]
    }
  ];

  return (
    <>
      <style>
        {`
          @media print {
            body { margin: 0; padding: 0; background: white; }
            .no-print { display: none !important; }
            .print-content { margin: 0; padding: 0.5cm; width: 100%; }
            .print-content h1 { font-size: 18pt; margin-bottom: 10pt; }
            .print-content h2 { font-size: 14pt; margin-top: 15pt; margin-bottom: 8pt; page-break-after: avoid; }
            .print-content h3 { font-size: 12pt; margin-top: 10pt; margin-bottom: 6pt; }
            .print-content p { font-size: 10pt; line-height: 1.4; margin-bottom: 6pt; page-break-inside: avoid; }
            .print-content .faq-item { margin-bottom: 8pt; page-break-inside: avoid; }
            .print-content .faq-item strong { font-weight: bold; }
            @page { size: A4; margin: 1.5cm; }
            .print-faq-toggle { display: none !important; }
          }
        `}
      </style>

      <div className="min-h-screen bg-gray-50 pt-2 pb-12">
        <div className="max-w-4xl mx-auto px-4">
          {/* Header */}
          <div className="no-print bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <img
                  src={`${process.env.PUBLIC_URL}/img/logo2.png`}
                  alt="Brechó Vizinho"
                  className="h-12 w-auto object-contain"
                />
                <div>
                  <h1 className="text-xl font-bold text-gray-800">Perguntas Frequentes</h1>
                  <p className="text-xs text-gray-500">Versão 1.0 | 15/06/2026</p>
                </div>
              </div>
              
              <div className="flex gap-3">
                <button
                  onClick={() => window.history.back()}
                  className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  <ArrowLeft className="w-4 h-4" />
                  <span className="hidden sm:inline">Voltar</span>
                </button>
                <button
                  onClick={handleDownloadPDF}
                  disabled={isGeneratingPDF}
                  className="flex items-center gap-2 px-4 py-2 bg-[#449879] text-white rounded-lg hover:bg-[#2d5f4d] transition-colors disabled:opacity-50"
                >
                  {isGeneratingPDF ? (
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  ) : (
                    <Download className="w-4 h-4" />
                  )}
                  <span className="hidden sm:inline">Baixar PDF</span>
                </button>
              </div>
            </div>
          </div>

          {/* Conteúdo */}
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8 print:shadow-none print:p-0 print:bg-white">
            <div className="print-content prose prose-sm max-w-none prose-headings:text-gray-800 prose-p:text-gray-600 prose-strong:text-gray-800">
              
              {/* TÍTULO */}
              <div className="text-center mb-8 print:mb-4">
                <h1 className="text-2xl font-bold text-gray-800 mb-2">Perguntas Frequentes (FAQ)</h1>
                <p className="text-sm text-gray-500">Versão 1.0 | Data de Vigência: 15/06/2026</p>
                <div className="w-20 h-1 bg-[#449879] mx-auto mt-3 rounded-full print:bg-gray-400" />
              </div>

              {/* FAQ - Versão para impressão (tudo aberto) */}
              <div className="hidden print:block">
                {faqData.map((section) => (
                  <div key={section.id} className="mb-8">
                    <h2 className="text-lg font-bold text-gray-800 mb-4 pb-2 border-b border-gray-200">
                      {section.title}
                    </h2>
                    {section.items.map((item, index) => (
                      <div key={index} className="faq-item mb-4">
                        <p className="font-semibold text-gray-800 mb-1">
                          {item.question}
                        </p>
                        <p className="text-gray-600 pl-4">
                          {item.answer}
                        </p>
                      </div>
                    ))}
                  </div>
                ))}
              </div>

              {/* FAQ - Versão interativa (accordion) */}
              <div className="print:hidden space-y-6">
                {faqData.map((section) => {
                  const isOpen = openSections[section.id] || false;
                  
                  return (
                    <div key={section.id} className="border border-gray-200 rounded-xl overflow-hidden">
                      {/* Título da seção - clicável */}
                      <button
                        onClick={() => toggleSection(section.id)}
                        className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
                      >
                        <h2 className="text-base font-semibold text-gray-800">
                          {section.title}
                        </h2>
                        {isOpen ? (
                          <ChevronUp className="w-5 h-5 text-gray-400 flex-shrink-0" />
                        ) : (
                          <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" />
                        )}
                      </button>
                      
                      {/* Itens da seção */}
                      <div className={`transition-all duration-300 overflow-hidden ${
                        isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
                      }`}>
                        <div className="p-4 space-y-4">
                          {section.items.map((item, index) => (
                            <div key={index} className="border-b border-gray-100 last:border-0 pb-4 last:pb-0">
                              <p className="font-semibold text-gray-800 text-sm mb-1">
                                {item.question}
                              </p>
                              <p className="text-gray-600 text-sm leading-relaxed pl-2">
                                {item.answer}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* ASSINATURA FINAL */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-sm text-gray-500">
                  Última atualização: 15/06/2026<br />
                  Versão: 1.0<br />
                  Brechó Vizinho<br />
                  Responsável pelo Tratamento de Dados Pessoais (DPO): Gustavo Gonzalez<br />
                  E-mail: <span className="text-[#449879] font-medium">info@brechovizinho.com.br</span><br />
                  Canal LGPD: <span className="text-[#449879] font-medium">privacidade@brechovizinho.com.br</span>
                </p>
              </div>
            </div>
          </div>

          {/* Botão voltar ao topo */}
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="no-print fixed bottom-20 right-4 bg-[#449879] text-white p-3 rounded-full shadow-lg hover:bg-[#2d5f4d] transition-colors z-40"
            aria-label="Voltar ao topo"
          >
            ↑
          </button>
        </div>
      </div>
    </>
  );
}